import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { GetSession, RemoveSession } from "session-manager-beta";
import BlurLoader from "./components/CommonComponents/BlurFullPageLoader";
import Header from "./components/Layout/Header";
import SideBar from "./components/Layout/SideBar";

const Protected = (Props) => {
    const { Component } = Props;
    const navigate = useNavigate();
    const [auth, setAuth] = useState(false);
    const subLoading = useSelector(state => state.auth.loading)
    const { open } = useSelector((state) => state.header);
    const checkLogin = async () => {
        const user = await GetSession('cookies', 'user');
        if (!user?.loginSessionID || user?.loginSessionID === 'EXPIRED') {
            RemoveSession('cookies', 'user')
            navigate('/');
            setAuth(false);
        } else {
            setAuth(true);
        }
    };

    useEffect(() => {
        checkLogin();
    }, [])

    return auth ? (
        <>
            <Header />
            <SideBar />
            <main id="main" className="main" style={open ? { marginLeft: "250px" } : { marginLeft: "0" }}>
                <Component />
            </main>
            {subLoading && <BlurLoader />}
        </>
    ) : <></>
}
export default Protected;